import type { LetterStatus } from "../_logic/types";

/** Tile and key colors per status, shared by the board and keyboard. */
export const STATUS_CLASSES: Record<LetterStatus, string> = {
  correct: "bg-emerald-600 border-emerald-600 text-white",
  present: "bg-amber-500 border-amber-500 text-white",
  absent: "bg-slate-400 border-slate-400 text-white",
};
